import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createCvletter,
  fetchAllCvletters,
  updateCvletter,
  fetchOneCvletter,
  deleteCvletter,
  fetchGenerateRefid,
  createCvletterDetail,
  fetchAllCvletterDetails,
  updateCvletterDetail,
  fetchOneCvletterDetail,
  deleteCvletterDetail,
  printCvletter,
} from "services/cvletter";

// CVLetter Hooks
export const useGenerateRefid = () => {
  const query = useQuery({
    queryKey: ["generate-refid"],
    queryFn: () => fetchGenerateRefid(),
  });
  return query;
};
export const useAllCvletters = (filters = {}) => {
  const query = useQuery({
    queryKey: ["all-cvletters", filters],
    queryFn: () => fetchAllCvletters(filters),
  });
  return query;
};

export const useOneCvletter = (id) => {
  const query = useQuery({
    queryKey: ["one-cvletter", id],
    queryFn: () => {
      if (id) {
        return fetchOneCvletter(id);
      }
    },
    enabled: !!id,
  });
  return query;
};

export const useCreateCvletter = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (data) => createCvletter(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["all-cvletters"] });
    },
  });
  return mutation;
};

export const useUpdateCvletter = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ id, data }) => updateCvletter(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["all-cvletters"] });
      queryClient.invalidateQueries({ queryKey: ["one-cvletter"] });
    },
  });
  return mutation;
};

export const useDeleteCvletter = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (id) => deleteCvletter(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["all-cvletters"] });
    },
  });
  return mutation;
};

// CVLetter Detail Hooks
export const useAllCvletterDetails = (filters = {}) => {
  const query = useQuery({
    queryKey: ["all-cvletterdetails", filters],
    queryFn: () => fetchAllCvletterDetails(filters),
  });
  return query;
};

export const useOneCvletterDetail = (id) => {
  const query = useQuery({
    queryKey: ["one-cvletterdetail", id],
    queryFn: () => {
      if (id) {
        return fetchOneCvletterDetail(id);
      }
    },
    enabled: !!id,
  });
  return query;
};

export const useCreateCvletterDetail = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (data) => createCvletterDetail(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["all-cvletterdetails"] });
    },
  });
  return mutation;
};

export const useUpdateCvletterDetail = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ id, data }) => updateCvletterDetail(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["all-cvletterdetails"] });
      queryClient.invalidateQueries({ queryKey: ["one-cvletterdetail"] });
    },
  });
  return mutation;
};

export const useDeleteCvletterDetail = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (id) => deleteCvletterDetail(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["all-cvletterdetails"] });
    },
  });
  return mutation;
};

export const usePrintCvletter = () => {
  const mutation = useMutation({
    mutationFn: ({ id, withRecon }) => printCvletter(id, withRecon),
  });
  return mutation;
};
